import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackSettingsChangedParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/account/trackSettingsChanged";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackSettingsChanged = (
    parameters: PartialSpecific<
        TrackSettingsChangedParameters,
        "defaults_changed" | "subscription_status_changed"
    > = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.settingsChanged, parameters, options);
};

export default useTrackSettingsChanged;
